import { useState, useEffect } from 'react';
import { shouldForceDesktop } from '../utils/layoutDetection';

export type LayoutMode = 'mobile' | 'desktop';

/**
 * Hook para detectar el modo de layout adecuado y actualizar el viewport si es necesario.
 */
export const useLayoutMode = (): LayoutMode => {
    const [layoutMode, setLayoutMode] = useState<LayoutMode>('mobile');

    useEffect(() => {
        const updateLayoutMode = () => {
            const forceDesktop = shouldForceDesktop();
            const newMode = forceDesktop ? 'desktop' : 'mobile';

            setLayoutMode(newMode);

            // Manejo dinámico del meta viewport
            let viewport = document.querySelector('meta[name="viewport"]');
            if (!viewport) {
                viewport = document.createElement('meta');
                viewport.setAttribute('name', 'viewport');
                document.head.appendChild(viewport);
            }

            if (forceDesktop) {
                // Forzar el ancho real de la pantalla para evitar escalado mobile
                viewport.setAttribute('content', `width=${window.screen.width}, initial-scale=1`);
                console.log('[useLayoutMode] Forzando modo Desktop - Viewport actualizado');
            } else {
                // Comportamiento responsive normal
                viewport.setAttribute('content', 'width=device-width, initial-scale=1');
            }
        };

        // Ejecutar al montar
        updateLayoutMode();

        // Reaccionar a cambios de tamaño de ventana
        window.addEventListener('resize', updateLayoutMode);

        return () => {
            window.removeEventListener('resize', updateLayoutMode);
        };
    }, []);

    return layoutMode;
};
